import React,{useState,useEffect} from 'react';
import Header from './Header';
import Footer from './Footer';
import WhatsAppButton from './whatsapp';
import axios from 'axios';
import { uploadUrl } from './uploadUrl';
import Chat from './chat';
import Call from './call';
import Marquee from './marquee';


const SampleProjects=()=>{
   const [affordable,setaffordable]=useState([]);
   const [design,setdesign]=useState([]);
   
  useEffect(()=>{
 
     const fetchaffordable=async()=>{
      try{
     const res= await axios.get(`https://api.squareandangle.pranatigroup.in/api/admin/affordable`);
     setaffordable(res.data);
      }catch(error){
      console.error(error);
      }
    }
    const fetchdesign=async()=>{
      try{
     const res= await axios.get(`https://api.squareandangle.pranatigroup.in/api/admin/designidea`);
     console.log(res.data);
     setdesign(res.data);
      }catch(error){
      console.error(error);
      }
    }
    fetchdesign();
   fetchaffordable();
  },[]);

  const handleshare = async (item) => {
  const imageUrl = uploadUrl(item.image);

  try {
    const response = await fetch(imageUrl);
    const blob = await response.blob();

    const file = new File(
      [blob],
      "image.jpg",
      { type: blob.type || "image/jpeg" }
    );

    const shareData = {
      title: item.title,
      text: item.description,
      files: [file],
      url:window.location.href
    };

    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      await navigator.share(shareData);
    } else if (navigator.share) {
     
      await navigator.share({
        title: item.title,
        text: item.description,
        image: imageUrl,
        url:window.location.href
      });
    } else {
      await navigator.clipboard.writeText(imageUrl);
    }
  } catch (error) {
    if (error.name !== "AbortError") {
      console.error("Share failed:", error);
    }
  }
};

  

    return(
    <>
    <div className='app'>
   <Header />
   <Marquee/>
   
    <div className="breadcumb-area black-opacity bg-img-6">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="breadcumb-wrap">
                        <h2>Completed Interior Ideas</h2>
                        <ul>
                            <li>Today we are very happy that able to give 5000 customers their best interior design. In the future, we will create and show better interiors.</li>
                            <li></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
   
    
   
 <div
  className="livspace-about-section"
  style={{
    background: "#fff",
    padding: "90px 20px",
    overflow: "hidden",
  }}
>
  <div
    style={{
      maxWidth: "1200px",
      margin: "0 auto",
    }}
  >

    {/* =====================================================
        TOP HEADING
    ====================================================== */}

    <div
      style={{
        maxWidth: "850px",
        marginBottom: "55px",
      }}
    >
      

      

      
    </div>


    {/* =====================================================
        MAIN GRID
    ====================================================== */}

    <div
      className="livspace-main-grid"
      style={{
        display: "grid",
        gridTemplateColumns: "minmax(0, 2fr) minmax(280px, 1fr)",
        gap: "55px",
        alignItems: "start",
      }}
    >

      {/* =====================================================
          LEFT CONTENT
      ====================================================== */}

      <div>

        {/* =================================================
            SEPARATE IMAGE LIST
        ================================================== */}

        <div
  className="livspace-image-list"
  style={{
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "20px",
    width: "100%",
    marginBottom: "40px",
  }}
>
  {design.map((item, index) => (
    <div
      key={item.id || index}
      className="livspace-image-card"
      style={{
        width: "100%",
      }}
    >
      <div
        className="livspace-single-image"
        style={{
          width: "100%",
          height: "250px",
          overflow: "hidden",
          borderRadius: "8px",
          background: "#f3f3f3",
          boxShadow: "0 6px 20px rgba(0,0,0,.10)",
          position: "relative",
        }}
      >
        <img
          src={uploadUrl(item.image)}
          title={`Interior Design Kolkata ${index + 1}`}
          alt={`Interior Design Kolkata ${index + 1}`}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
          }}
        />
       
      <button
  type="button" onClick={()=>handleshare(item)}
  aria-label={`Share Interior Design ${index + 1}`}
  title="Share"
  style={{
    position: "absolute",
    right: "12px",
    top: "12px",
    width: "42px",
    height: "42px",
    border: "none",
    borderRadius: "8px",
    background: "#e5e2df",
    color: "#333",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    boxShadow: "0 3px 10px rgba(0,0,0,.18)",
    zIndex: 10,
    padding: 0,
  }}
>
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="18" cy="5" r="3" />
    <circle cx="6" cy="12" r="3" />
    <circle cx="18" cy="19" r="3" />
    <line x1="8.6" y1="13.5" x2="15.4" y2="17.5" />
    <line x1="15.4" y1="6.5" x2="8.6" y2="10.5" />
  </svg>
</button>

        
      </div>
    </div>
  ))}
</div>



        {/* =================================================
            DESCRIPTION
        ================================================== */}

        

      </div>


      {/* =====================================================
          RIGHT SIDEBAR
      ====================================================== */}

    <div
  className="livspace-sidebar"
  style={{
    position: "sticky",
    top: "30px",
  }}
>
 

  <div
  className="video-call-tree"
  style={{
    position: "relative",
    padding: "10px 0 10px 34px",
  }}
>
  {/* =================================================
      TREE TRUNK
  ================================================== */}

  <div
    style={{
      position: "absolute",
      left: "10px",
      top: "38px",
      bottom: "38px",
      width: "2px",
      background:
        "linear-gradient(to bottom, #f04f70, #f7a1b2, #f04f70)",
      borderRadius: "10px",
    }}
  />

  {/* =================================================
      ROOT / VIDEO CALL HEADER
  ================================================== */}

  <div
    style={{
      position: "relative",
      marginBottom: "18px",
      padding: "22px 20px",
      background: "#fff7f9",
      border: "1px solid #f04f70",
      borderRadius: "20px",
      textAlign: "center",
    }}
  >
    {/* Root connection */}
    <div
      style={{
        position: "absolute",
        left: "-25px",
        top: "50%",
        width: "25px",
        height: "2px",
        background: "#f04f70",
      }}
    />

    <div
      style={{
        width: "46px",
        height: "46px",
        margin: "0 auto 10px",
        borderRadius: "50%",
        background: "#f04f70",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "20px",
      }}
    >
      📹
    </div>

    <h3
      style={{
        margin: "0 0 5px",
        fontSize: "19px",
        lineHeight: "1.3",
        color: "#111",
        fontWeight: "700",
      }}
    >
      1:1 Interior Video Call
    </h3>

    <p
      style={{
        margin: 0,
        color: "#707070",
        fontSize: "12px",
        lineHeight: "1.5",
      }}
    >
      Show us your room and get a personalized quotation.
    </p>
  </div>

  {/* =================================================
      STEPS
  ================================================== */}

  {[
    {
      number: "1",
      icon: "📅",
      title: "Schedule Google Meet",
      description:
        "Choose a convenient date and time for your personal video consultation.",
      button: "Schedule Call",
      action: "#",
    },
    {
      number: "2",
      icon: "💬",
      title: "Get Meet Link on WhatsApp",
      description:
        "Your Google Meet details will be sent directly to you on WhatsApp.",
      button: "Continue on WhatsApp",
      action:
        "https://api.whatsapp.com/send?phone=6289001010&text=Hi%20Pranati%20Interior!%20I%20have%20scheduled%20a%201%3A1%20video%20consultation.",
    },
    {
      number: "3",
      icon: "🏠",
      title: "Show Us Your Room",
      description:
        "Join the video call and walk our designer through your actual space.",
      button: "Join Video Call",
      action: "#",
    },
    {
      number: "4",
      icon: "₹",
      title: "Get Your Quotation",
      description:
        "Discuss your requirements and receive a quotation based on your space.",
      button: "Get Quotation",
      action: "#",
    },
  ].map((step, index) => (
    <div
      key={step.number}
      style={{
        position: "relative",
        marginBottom: index !== 3 ? "16px" : "0",
      }}
    >
      {/* =================================================
          BRANCH FROM TREE
      ================================================== */}

      <div
        style={{
          position: "absolute",
          left: "-24px",
          top: "50%",
          width: "24px",
          height: "2px",
          background: "#f04f70",
        }}
      />

      {/* =================================================
          TREE NODE
      ================================================== */}

      <div
        style={{
          position: "absolute",
          left: "-30px",
          top: "50%",
          transform: "translateY(-50%)",
          width: "10px",
          height: "10px",
          background: "#fff",
          border: "2px solid #f04f70",
          borderRadius: "50%",
          zIndex: 3,
        }}
      />

      {/* =================================================
          STEP CARD
      ================================================== */}

      <div
        style={{
          position: "relative",
          minHeight: "135px",
          padding: "20px",
          border: "1px solid #f1d8de",
          borderRadius: "18px",
          background: "#fff",
          boxShadow: "0 4px 18px rgba(240,79,112,.06)",
          boxSizing: "border-box",
        }}
      >
        {/* Step number */}

        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            gap: "12px",
          }}
        >
          <div
            style={{
              width: "32px",
              height: "32px",
              minWidth: "32px",
              borderRadius: "50%",
              background: "#fff0f3",
              color: "#f04f70",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "13px",
              fontWeight: "700",
            }}
          >
            {step.number}
          </div>

          <div style={{ flex: 1 }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "7px",
                marginBottom: "5px",
              }}
            >
              <span
                style={{
                  fontSize: "15px",
                }}
              >
                {step.icon}
              </span>

              <h4
                style={{
                  margin: 0,
                  color: "#111",
                  fontSize: "15px",
                  lineHeight: "1.3",
                  fontWeight: "700",
                }}
              >
                {step.title}
              </h4>
            </div>

            <p
              style={{
                margin: "0 0 12px",
                color: "#707070",
                fontSize: "11px",
                lineHeight: "1.55",
              }}
            >
              {step.description}
            </p>

            <a
              href={step.action}
              target={
                step.action.startsWith("http") ? "_blank" : undefined
              }
              rel={
                step.action.startsWith("http")
                  ? "noopener noreferrer"
                  : undefined
              }
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                padding: "7px 11px",
                background: "#ed5271",
                color: "#fff",
                borderRadius: "7px",
                textDecoration: "none",
                fontSize: "11px",
                fontWeight: "600",
              }}
            >
              {step.button}
              <span style={{ fontSize: "14px" }}>→</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  ))}
</div>

</div>


    </div>

  </div>


  {/* =====================================================
      RESPONSIVE CSS
  ====================================================== */}

  <style>
    {`

      /* =========================================
         BASE
      ========================================= */

      .livspace-about-section {
        box-sizing: border-box;
      }

      .livspace-about-section *,
      .livspace-about-section *::before,
      .livspace-about-section *::after {
        box-sizing: border-box;
      }


      /* =========================================
         SEPARATE IMAGE CARDS
      ========================================= */

      .livspace-image-list {
        width: 100%;
      }

      .livspace-image-card {
        width: 100%;
      }

      .livspace-single-image {
        position: relative;
        width: 100%;
      }

      .livspace-single-image img {
        transition: transform .6s ease;
      }

      .livspace-image-card:hover
      .livspace-single-image img {
        transform: scale(1.03);
      }


      /* =========================================
         SERVICE HOVER
      ========================================= */

      .livspace-service-item:hover {
        background: #fafafa;
        color: #e56b2f !important;
      }

      .livspace-service-item:hover span:first-child {
        background: #e56b2f !important;
        color: #fff !important;
      }


      /* =========================================
         CTA HOVER
      ========================================= */

      .livspace-sidebar a:hover {
        background: #d95c22 !important;
      }


      /* =========================================
         TABLET
      ========================================= */

      @media (max-width: 991px) {

        .livspace-about-section {
          padding: 70px 20px !important;
        }

        .livspace-main-grid {
          grid-template-columns: 1fr !important;
          gap: 45px !important;
        }

        .livspace-sidebar {
          position: relative !important;
          top: auto !important;
        }

        .livspace-about-section h1 {
          font-size: 38px !important;
        }

        .livspace-single-image {
          height: 430px !important;
        }

      }


      /* =========================================
         MOBILE
      ========================================= */

      @media (max-width: 767px) {

        .livspace-about-section {
          padding: 55px 15px !important;
        }

        .livspace-about-section h1 {
          font-size: 30px !important;
          line-height: 1.2 !important;
          letter-spacing: -.5px !important;
        }

        .livspace-about-section p {
          font-size: 15px !important;
        }

        .livspace-image-list {
          gap: 22px !important;
          margin-bottom: 35px !important;
        }

        .livspace-single-image {
          height: 350px !important;
          border-radius: 6px !important;
        }

        .livspace-feature-grid {
          grid-template-columns: 1fr !important;
        }

        .livspace-sidebar {
          width: 100%;
        }

      }


      /* =========================================
         SMALL MOBILE
      ========================================= */

      @media (max-width: 480px) {

        .livspace-about-section {
          padding: 45px 12px !important;
        }

        .livspace-about-section h1 {
          font-size: 27px !important;
        }

        .livspace-image-list {
          gap: 18px !important;
        }

        .livspace-single-image {
          height: 280px !important;
          border-radius: 5px !important;
        }

        .livspace-sidebar > div {
          padding: 24px 20px !important;
        }

      }

    `}
  </style>

</div>


   
   
   
    
    <Footer />
   
      <WhatsAppButton />
      <Chat/>
      <Call/>
      
    
</div>
    </>
    )
}
export default SampleProjects;